export default __webpack_public_path__ + "static/media/selectRed.850da3f8.svg";